<template>
  <div id="about">
    <el-container>
      <div style="margin-top:40px;">
        <div style="margin:40px 100px;">          
          <div style="padding:40px;background-color:#ffffff;margin-bottom:20px;">
            <div class="title" style="margin-bottom:40px;">— 公司介绍 —</div>  
            <el-row :gutter="40">              
              <el-col :span="9">
                <img src="../assets/images/about.png" class="about" alt="">
              </el-col>
              <el-col :span="15">                              
                <div style="font-size:14px;line-height:28px;text-align:justify">北京太智联合企业管理顾问有限公司（简称∶太智联合）www.taizhicn.com是国内人力资源智能服务商，薪酬数据智库，业务覆盖薪酬调研、薪酬设计、岗位测评、企业培训、管理咨询和敬业度调查等。</div>
                <div style="font-size:14px;line-height:28px;text-align:justify">作为人力资源数据咨询公司，太智联合拥有完整的企业人力资源数据库系统，线上薪酬智能查询平台是覆盖百城市百行业的免费开放薪酬数据交互系统。</div>
                <div style="font-size:14px;line-height:28px;text-align:justify">除此之外，众多银行系统或征信机构也将我司的薪酬数据库作为评估职工收入信用的主要依据，多家知名媒体争相引用太智联合调研成果。</div>
                <div style="font-size:14px;line-height:28px;text-align:justify">太智联合借助庞大的薪酬数据查询系统和在线测评系统，建立广泛的HR服务商联盟体系，方便客户快速在全国各地找到需要的HR产品服务商，业务辐射猎头服务、团建拓展、企业培训、管理咨询、劳务派遣、企业福利等多方向，太智联合致力于为客户创造更好地服务体验，为合作伙伴提供及时的需求信息。</div>
              </el-col>
            </el-row>
          </div>
          <div style="padding:40px;background-color:#ffffff;margin-bottom:20px;" >
            <el-row>
              <el-col :span="24">
                <div  class="title">— 历史足迹 —</div>
                <div class="block">
                  <el-timeline>
                    <el-timeline-item timestamp="2019年" placement="top" size="large" color='#59DAF7'>
                      <el-card  style="box-shadow:1px 1px 10px #b0f1ff">
                        <p>建立全国HR服务联盟体系，200多个城市的HR服务商携手共创未来</p>
                      </el-card>
                    </el-timeline-item>
                    <el-timeline-item timestamp="2015年" placement="top" color='#51BEF6'>
                      <el-card  style="box-shadow:1px 1px 10px #8fd9ff">
                        <p>与看准网、BOSS直聘、58集团、浙江外服达成战略合作</p>
                      </el-card>
                    </el-timeline-item>
                    <el-timeline-item timestamp="2014年" placement="top" color='#6D9FE8'>
                      <el-card  style="box-shadow:1px 1px 10px #a9c7f2">
                        <p>与易才集团、知远咨询达成战略合作</p>
                      </el-card>
                    </el-timeline-item>
                    <el-timeline-item timestamp="2013年" placement="top" color='#8D7CCB'>
                      <el-card  style="box-shadow:1px 1px 10px #bdb1eb">
                        <p>与中华英才网、举贤网达成战略合作</p>
                      </el-card>
                    </el-timeline-item>
                    <el-timeline-item timestamp="2012年" placement="top" color='#A2579E'>
                      <el-card style="box-shadow:1px 1px 10px #d2a9d0">
                        <p>与智联招聘线上薪酬数据库达成战略合作</p>
                      </el-card>
                    </el-timeline-item>
                  </el-timeline>
                </div>
              </el-col>
            </el-row>
          </div>
          <div style="padding:40px;background-color:#ffffff;margin-bottom:20px;">
            <el-row>
              <el-col :span="24">
                <div class="title">— 公司地址 —</div>
                <div id="mapCanvas" class="" style="height:450px;"></div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>
<script>
export default {
  name:'about',
  mounted(){
    var map = new BMap.Map("mapCanvas");        // 创建Map实例
    var point = new BMap.Point("116.70198", "39.876822");    // 创建点坐标116.70198,39.876822
    map.centerAndZoom(point,15);                // 初始化地图,设置中心点坐标和地图级别。
    map.enableScrollWheelZoom();                  //启用滚轮放大缩小
    //添加缩放控件
    map.addControl(new BMap.NavigationControl());
    map.addControl(new BMap.ScaleControl());
    map.addControl(new BMap.OverviewMapControl());

    var marker = new BMap.Marker(point); // 创建标注
    map.addOverlay(marker); // 将标注添加到地图中
    var infoWindow = new BMap.InfoWindow("太智联合<br/><span class=''>地址：北京市华远好天地A座</span><br/><span class=''>电话：400-809-8577</span><br/><span class=''>邮箱：tz@taizhicn.com</span>"); // 创建信息窗口对象
    marker.openInfoWindow(infoWindow);
  }
}
</script>
<style scoped>
#about {
  background-color: #f4f4f4;
}
.main-container {
  margin: 0 100px;
}
.title{
  font-size: 22px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: #333;
  line-height: 30px;
  letter-spacing: 1px;
  text-align: center;
  padding: 0 0 20px 0;
}
.about{
  width: 100%;
}
</style>
